import { cn } from "@/libs/utils";

export const Dot = ({
  className,
  visible,
}: {
  className?: string;
  visible?: boolean;
}) =>
  !visible ? null : (
    <span
      className={cn(
        "absolute left-full top-0 ml-1 block min-h-1 min-w-1 rounded-full bg-red-60",
        className,
      )}
    />
  );
